// const jQuery = require('jquery') // loaded from cdn globally

const scrollMixin = {
  methods: {
    scrollUnderVideo () {
      const scrollTop = $(".interactive-view").offset().top

      this.$vuetify.goTo(scrollTop, {
        duration: 1000,
        easing: 'easeInOutCubic',
      })


      /*const appBarHeight = this.$vuetify.breakpoint.md ? 64 : 56

      let scrollHeight = document.getElementById('viewer').offsetHeight + appBarHeight

      const swipers = document.getElementsByClassName('partners-swiper')
      if (swipers.length) {
        scrollHeight += swipers[0].offsetHeight
      }

      this.$vuetify.goTo(scrollHeight, {
        duration: 1000,
        easing: 'easeInOutCubic',
      })*/
    }
  }
}

export default scrollMixin
